import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Application } from '@modules/common/types/application';
import { SpaceContextStore } from '@modules/common/services/SpaceContextStore';
import { AppRoutesMap } from '@modules/pages/types/app-routes.map';
import { notesWorkspacePath } from '@modules/notes/routing/notes-workspace-route';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';

@Component({
  selector: 'app-atlas-proto-part',
  templateUrl: './atlas-proto-part.component.html',
  styleUrls: ['./atlas-proto-part.component.less'],
  host: { slot: 'apps', class: 'contents' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AtlasProtoPartComponent {
  public readonly app = input.required<Application>();
  protected readonly appContextMenuOpened = signal(false);
  private readonly advancedSearchService = inject(AdvancedSearchService);
  private readonly router = inject(Router);
  private readonly spaceContextStore = inject(SpaceContextStore);

  protected handleAppChange(app: Application): void {
    this.advancedSearchService.resetState();
    const route = AppRoutesMap.find((item) => item.app === app)?.path;
    if (!route) {
      return;
    }
    const destination = app === Application.notes
      ? notesWorkspacePath(this.spaceContextStore.insideTeam() ? this.spaceContextStore.contextId() : undefined)
      : route;
    this.router.navigate([destination]);
  }
}
